import { Component, OnInit } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { CupsService } from '../../../services/cups.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  currentYear: number = new Date().getFullYear();
  public bot_url: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl("/assets/images/ludobot/LudoBot.html?user=");
  username: any;
  userAdmin: any;
  clickEventSubscription: Subscription;
  constructor(private sanitizer: DomSanitizer, private service: CupsService) {
    this.clickEventSubscription = this.service.getLudoBotEvent().subscribe(() => {
      this.ludoBot();
    });
  }
  ngOnInit(): void {
  
  }

  ludoBot() {
    let setSrc = true;
    this.username = sessionStorage.getItem('loginuser');
    this.userAdmin = (sessionStorage.getItem('IsAdmin') === "1" || sessionStorage.getItem('IsAdmin') === "true") ? true : false;
    let objuser = sessionStorage.getItem('loginuseremail') + ',' + sessionStorage.getItem('loginuser');
    let username = objuser;
    if (setSrc) {
      this.bot_url = this.sanitizer.bypassSecurityTrustResourceUrl("/assets/images/ludobot/LudoBot.html?user=" + username);
      console.log(this.bot_url);
      setSrc = false;
    }
  }
  
}
